import { createSelector } from "reselect";
import { AccountType, ChartOfAccounts, ChartOfAccountsItem } from "../../api/biApi.types";
import { dataSetMetaDataEmpty } from "../slices/metaDataSlice";
import { RootState } from "../types/store.types";
import { filterDimensions } from "../utils/filterDimensionsByReportType";

export const selectMetaDataLoaded = (state: RootState) => state.metaData.loaded;
export const selectMetaDataLoadingFailed = (state: RootState) => state.metaData.loadingFailed;
export const selectMetaData = (state: RootState) => state.metaData;
export const selectCurrentDataSetId = (state: RootState) => state.metaData.dataSetId;
const selectCurrentDataSet = (state: RootState) =>
  state.metaData.dataSets.find((d) => d.dataSetId === state.metaData.dataSetId) ?? dataSetMetaDataEmpty;
export const selectDimensions = createSelector(selectCurrentDataSet, (state) => state.dimensions);
export const selectDimensionsStructure = createSelector(selectCurrentDataSet, (state) => state.dimensionsStructure);
export const selectMeasures = createSelector(selectCurrentDataSet, (state) => state.measures);
export const selectMeasuresStructure = createSelector(selectCurrentDataSet, (state) => state.measuresStructure);
export const selectMetrics = createSelector(selectCurrentDataSet, (state) => state.metrics);
export const selectMetricsStructure = createSelector(selectCurrentDataSet, (state) => state.metricsStructure);
export const selectFunctions = createSelector(selectCurrentDataSet, (state) => state.functions);
export const selectMeasureGroups = createSelector(selectCurrentDataSet, (state) => state.measureGroups);
export const selectChartOfAccountsState = (state: RootState) => state.metaData.chartOfAccounts;
export const selectDimensionDictionary = (name: string | undefined) =>
  createSelector(selectCurrentDataSet, (state) => state.dimensions.find((d) => d.name === name)?.dictionary);

export const selectDimensionsForCurrentReportType = createSelector(
  selectDimensions,
  (state: RootState) => state.metaData.reportType,
  (dimensions, reportType) => filterDimensions(reportType, dimensions)
);

export const selectPostingChartOfAccounts = createSelector(selectChartOfAccountsState, (chartOfAccounts) => {
  if (chartOfAccounts) {
    return {
      gl: chartOfAccounts.gl?.filter(filterPosting) || [],
      memo: chartOfAccounts.memo?.filter(filterPosting) || [],
    } as ChartOfAccounts;
  }
  return undefined;
});

export const selectChartOfAccounts = createSelector(selectChartOfAccountsState, (chartOfAccounts) => {
  if (chartOfAccounts) {
    return {
      gl: chartOfAccounts.gl || [],
      memo: chartOfAccounts.memo || [],
    } as ChartOfAccounts;
  }
  return undefined;
});

function filterPosting(item: ChartOfAccountsItem) {
  return item.accountType === AccountType.Posting;
}

export const selectReportType = (state: RootState) => state.metaData.reportType;
